<template>
  <div>
    <partial-header @toggle-drawer="toggleDrawer" ref="header"></partial-header>
    <partial-drawer-navigation @close-drawer="showDrawer = false" :class="{'sidenav-open': showDrawer}"></partial-drawer-navigation>

    <div class="page">
      <template v-if="ready && !header"><router-view></router-view></template>
      <template v-else="">
        <transition tag="section" name="slide-fade" mode="out-in">
          <router-view></router-view>
        </transition>
      </template>
    </div>

    <cookies-modal />
    <partial-footer v-cloak v-if="ready && footer"></partial-footer>
  </div>
</template>

<script>
  import {mapState} from 'vuex'
  import PartialHeader from './pages/partials/PartialHeader'
  import PartialFooter from './pages/partials/PartialFooter'
  import PartialDrawerNavigation from './pages/partials/PartialDrawerNavigation'
  import CookiesModal from './components/app/CookiesModal'

  export default {
    components: {
      PartialDrawerNavigation,
      PartialHeader,
      PartialFooter,
      CookiesModal
    },
    data () {
      return {
        loading: false,
        showDrawer: false,
        ready: false
      }
    },
    computed: {
      header: function () {
        return this.hasHeader(this.$route)
      },
      footer: function () {
        return this.hasFooter(this.$route)
      },
      ...mapState({
        user: state => state.user
      })
    },
    watch: {
      '$route' (to, from) {
        this.showDrawer = false
      }
    },
    mounted () {
      if (this.$route.query.redirect) {
        let redirect = this.$route.query.redirect
        if (redirect.indexOf('?') >= 0) {
          let search = redirect.substring(redirect.indexOf('?') + 1)
          let query = JSON.parse('{"' + decodeURI(search).replace(/"/g, '\\"').replace(/&/g, '","').replace(/=/g, '":"') + '"}')
          if (query.company_id) {
            this.companyId = parseInt(query.company_id, 10)
          }
        }
      }
      let parent = this
      this.$router.onReady(function () {
        parent.ready = true
      })
    },
    methods: {
      toggleDrawer () {
        this.showDrawer = !this.showDrawer
      }
    }
  }
</script>

<style lang="scss">
  @import "./sass/main";
</style>



// WEBPACK FOOTER //
// App.vue?14ee2c96